import React, { useContext, useState } from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";

import GenericDialog from "components/shared/generic-dialog";
import { SnackbarContext } from "context/snackbar-context";

interface CreateTemplateSuccessDialogProps {
  open: boolean;
  onClose: () => void;
  newTemplateId: string;
}

const CreateTemplateSuccessDialog: React.FC<
  CreateTemplateSuccessDialogProps
> = ({ open, onClose, newTemplateId }) => {
  const theme = useTheme();
  const { copyToClipboard } = useContext(SnackbarContext);
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = () => {
    copyToClipboard(newTemplateId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <GenericDialog
      title="Template Created Successfully"
      open={open}
      handleDialogClose={onClose}
      hasAckBtn={true}
      acknowledgeBtnLabel="Close"
      width="sm"
    >
      <Grid container spacing={3} paddingTop={2}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 2,
              backgroundColor: theme.palette.grey[100],
              borderRadius: 1,
              border: `1px solid ${theme.palette.grey[300]}`,
            }}
          >
            <Box sx={{ flex: 1, marginRight: 1 }}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                New Template ID:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "monospace",
                  wordBreak: "break-all",
                }}
                data-testid="new-template-id"
              >
                {newTemplateId || "(Template ID not available)"}
              </Typography>
            </Box>
            <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
              <IconButton
                onClick={handleCopyToClipboard}
                color={copied ? "success" : "primary"}
                data-testid="copy-template-id-button"
                size="small"
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    </GenericDialog>
  );
};

export default CreateTemplateSuccessDialog;
